import React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import "./OrderProgressStepper.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faPhone } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { formatDateTime, ReturnStatus } from "../../../../../utils/common";
// Custom StepIcon Component
const CustomStepIcon = (props) => {
  const { active, completed, icon, disabled } = props;

  return completed ? (
    <FontAwesomeIcon icon={faCircleCheck} className="completed_step" />
  ) : (
    <div
      className="current_step_outer_circle"
      style={{
        backgroundColor: active ? "#C2F2D6" : "#fff",
      }}
    >
      <div
        className="current_step_inner_circle"
        style={{
          backgroundColor: active ? "#6EC090" : "#707070",
        }}
      >
        {/* {icon} */}
      </div>
    </div>
  );
};

export function VerticalLinearStepper({ order }) {
  // const steps = [
  //     { label: "Accepted Your Order", description: "Your order has been received."  },
  //     { label: "Preparing Your Order", description: "Your order will be ready to pick up shortly." },
  //     { label: "Order under Quality Check", description: "Your order is being inspected." },
  //     { label: "Order Picked up" }, // Example of a disabled step
  //     { label: "Order Ready to Deliver" }, // Example of a disabled step
  // ];

  // const activeStep = 2;
  // const completedSteps = [0, 1];

  const OrderStatusIds = {
    Processing: 2,
    PickupSchedued: 3,
    Shipped: 4,
    Delivered: 5,
    Cancelled: 6,
    Returned: 7,
    Refunded: 8,
    Replaced: 9,
  };

  const steps = [
    {
      label: "Order Accepted",
      description: "Your order has been received.",
      status: "completed",
    },
    {
      label: "Preparing Your Order",
      description: "Your order will be ready to pick up shorty",
      status:
        order?.order_status_id == OrderStatusIds.Processing
          ? "completed"
          : order?.order_status_id >= OrderStatusIds.Processing
          ? "completed"
          : "disabled",
    },
    {
      label: "Waiting For Pickup ",
      description: "Your order has been recieved",
      status:
        order?.order_status_id == OrderStatusIds.PickupSchedued
          ? "completed"
          : order?.order_status_id >= OrderStatusIds.PickupSchedued
          ? "completed"
          : "disabled",
    },
    {
      label: "Out For Delivery",
      status:
        order?.order_status_id == OrderStatusIds.Shipped
          ? "completed"
          : order?.order_status_id >= OrderStatusIds.Shipped
          ? "completed"
          : "disabled",
    },
    order?.order_status_id != OrderStatusIds.Cancelled
      ? {
          label: "ORDER READY TO DELIVER",
          status:
            order?.order_status_id == OrderStatusIds.Delivered
              ? "completed"
              : order?.order_status_id >= OrderStatusIds.Delivered
              ? "completed"
              : "disabled",
        }
      : {
          label: "ORDER READY TO DELIVER",
          status:
            order?.order_status_id == OrderStatusIds.Cancelled
              ? "completed"
              : "disabled",
        },
  ];

  return (
    <Box sx={{ maxWidth: 400 }} className="stepper_box">
      <div className="simple-stepper">
        {steps.map((step, index) => (
          <div key={index} className={`step ${step.status}`}>
            <div className="circle">
              {step.status === "completed" ? (
                <FontAwesomeIcon
                  icon={faCircleCheck}
                  className="completed_step"
                />
              ) : step.status === "active" ? (
                <div className="current_step_outer_circle">
                  <div className="current_step_inner_circle"></div>
                </div>
              ) : (
                <div className="disabled_outer">
                  <div className="circle-status disabled"></div>
                </div>
              )}
            </div>
            <div
              className={`content ${
                step.status === "disabled" ? "disabled-content" : ""
              }`}
            >
              {index === 1 ? (
                <div className="">
                  <p
                    className={`label ${
                      step.status === "disabled" ? "disabled-label" : ""
                    }`}
                  >
                    {step.label}
                  </p>
                  <p className="description">{step.description}</p>

                  {/* <Link to={`tel:+${order?.delivery_boy?.contact_no}`}>
                                        <div className="call_icon_holder">
                                            <div className="icon_holder">
                                                <FontAwesomeIcon icon={faPhone} className="call_icon" />
                                            </div>
                                            <div className="">
                                                <p className="icon_text">Call Store   </p>
                                            </div>
                                        </div>
                                    </Link> */}
                </div>
              ) : index !== 1 ? (
                <div className="">
                  <p
                    className={`label ${
                      step.status === "disabled" ? "disabled-label" : ""
                    }`}
                  >
                    {step.label}
                  </p>
                  <p className="description">{step.description}</p>
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </Box>
  );
}

export function VerticalLinearStepperReturnorder({ order }) {
  const OrderStatusIds = {
    ReturnRequested: ReturnStatus.ReturnRequested,
    PickupScheduled: ReturnStatus.PickupScheduled,
    ItemPicked: ReturnStatus.ItemPicked,
    Returned: ReturnStatus.Returned,
    Refunded: ReturnStatus.Refunded,
  };
console.log(order?.return_status_id,"order?.return_status_id order?.return_status_id");
console.log(order?.return_status_id === OrderStatusIds.ReturnRequested,"order?.return_status_id == OrderStatusIds.ReturnRequested");
console.log(OrderStatusIds.ReturnRequested,"OrderStatusIds.ReturnRequested");

  const steps = [
    {
      label: "Return Requested",
      description: "Your order has been received.",
      status:
        order?.return_status_id === OrderStatusIds.ReturnRequested
          ? "completed"
          : order?.return_status_id >= OrderStatusIds.ReturnRequested
          ? "completed"
          : "disabled",
    },
    {
      label: "Pickup Scheduled",
      description: "Your order will be ready to pick up shorty",
      status:
        order?.return_status_id == OrderStatusIds.PickupScheduled
          ? "completed"
          : order?.return_status_id >= OrderStatusIds.PickupScheduled
          ? "completed"
          : "disabled",
    },
    {
      label: "Item Picked",
      description: "Your order has been recieved",
      status:
        order?.return_status_id == OrderStatusIds.ItemPicked
          ? "completed"
          : order?.return_status_id>= OrderStatusIds.ItemPicked
          ? "completed"
          : "disabled",
    },
    {
      label: "Returned",
      description: "Your order has been recieved",
      status:
        order?.return_status_id == OrderStatusIds.Returned
          ? "completed"
          : order?.return_status_id >= OrderStatusIds.Returned
          ? "completed"
          : "disabled",
    },
    {
      label: "Refunded",
      description: "Your order has been recieved",
      status:
        order?.return_status_id == OrderStatusIds.Refunded
          ? "completed"
          : order?.return_status_id >= OrderStatusIds.Refunded
          ? "completed"
          : "disabled",
    },
  ];

  return (
    <Box sx={{ maxWidth: 400 }} className="stepper_box">
      <div className="simple-stepper">
        {steps.map((step, index) => (
          <div key={index} className={`step ${step.status}`}>
            <div className="circle">
              {step.status === "completed" ? (
                <FontAwesomeIcon
                  icon={faCircleCheck}
                  className="completed_step"
                />
              ) : step.status === "active" ? (
                <div className="current_step_outer_circle">
                  <div className="current_step_inner_circle"></div>
                </div>
              ) : (
                <div className="disabled_outer">
                  <div className="circle-status disabled"></div>
                </div>
              )}
            </div>
            <div
              className={`content ${
                step.status === "disabled" ? "disabled-content" : ""
              }`}
            >
              {index === 1 ? (
                <div className="">
                  <p
                    className={`label ${
                      step.status === "disabled" ? "disabled-label" : ""
                    }`}
                  >
                    {step.label}
                  </p>
                  <p className="description">{step.description}</p>

                  {/* <Link to={`tel:+${order?.delivery_boy?.contact_no}`}>
                                        <div className="call_icon_holder">
                                            <div className="icon_holder">
                                                <FontAwesomeIcon icon={faPhone} className="call_icon" />
                                            </div>
                                            <div className="">
                                                <p className="icon_text">Call Store   </p>
                                            </div>
                                        </div>
                                    </Link> */}
                </div>
              ) : index !== 1 ? (
                <div className="">
                  <p
                    className={`label ${
                      step.status === "disabled" ? "disabled-label" : ""
                    }`}
                  >
                    {step.label}
                  </p>
                  <p className="description">{step.description}</p>
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </Box>
  );
}

// export function VerticalLinearStepperReturnorder({ order }) {
//   const OrderStatusIds = {
// ReturnRequested: ReturnStatus.ReturnRequested,
// PickupScheduled: ReturnStatus.PickupScheduled,
// ItemPicked: ReturnStatus.ItemPicked,
// Returned: ReturnStatus.Returned,
// Refunded: ReturnStatus.Refunded,
//   };

// const steps = [
//   {
//     label: "Return Requested",
//     // description: "Your order has been received.",
//     tatus:
//       order?.return_status_id == OrderStatusIds.ReturnRequested
//         ? "active"
//         : order?.return_status_id > OrderStatusIds.ReturnRequested
//         ? "completed"
//         : "disabled",
//   },
//   {
//     label: "Pickup Scheduled",
//     // description: "Your order will be ready to pick up shorty",
//     status:
//       order?.return_status_id == OrderStatusIds.PickupScheduled
//         ? "active"
//         : order?.return_status_id > OrderStatusIds.PickupScheduled
//         ? "completed"
//         : "disabled",
//   },
//   {
//     label: "Item Picked",
//     description: "Your order has been recieved",
//       status:
//       order?.return_status_id == OrderStatusIds.ItemPicked
//         ? "active"
//         : order?.return_status_id == OrderStatusIds.ItemPicked
//         ? "completed"
//         : "disabled",

//   },
//   {
//     label: "Returned",
//     status:
//       order?.return_status_id == OrderStatusIds.Returned
//         ? "active"
//         : order?.return_status_id > OrderStatusIds.Returned
//         ? "completed"
//         : "disabled",
//   },
//   {
//     label: "Refunded",
//       status:
//       order?.return_status_id == OrderStatusIds.Refunded
//         ? "active"
//         : order?.return_status_id > OrderStatusIds.Refunded
//         ? "completed"
//         : "disabled",

//   },
// ];

//   return (
//     <Box sx={{ maxWidth: 400 }} className="stepper_box">
//       <div className="simple-stepper">

//         {steps.map((step, index) => (
//           <div key={index} className={`step ${step.status}`}>
//             <div className="circle">
//               {step.status === "completed" ? (
//                 <FontAwesomeIcon
//                   icon={faCircleCheck}
//                   className="completed_step"
//                 />
//               ) : step.status === "active" ? (
//                 <div className="current_step_outer_circle">
//                   <div className="current_step_inner_circle"></div>
//                 </div>
//               ) : (
//                 <div className="disabled_outer">
//                   <div className="circle-status disabled"></div>
//                 </div>
//               )}
//             </div>
//             <div
//               className={`content ${
//                 step.status === "disabled" ? "disabled-content" : ""
//               }`}
//             >
//               {index === 1 ? (
//                 <div className="">
//                   <p
//                     className={`label ${
//                       step.status === "disabled" ? "disabled-label" : ""
//                     }`}
//                   >
//                     {step.label}
//                   </p>
//                   <p className="description">{step.description}</p>

//                   {/* <Link to={`tel:+${order?.delivery_boy?.contact_no}`}>
//                                         <div className="call_icon_holder">
//                                             <div className="icon_holder">
//                                                 <FontAwesomeIcon icon={faPhone} className="call_icon" />
//                                             </div>
//                                             <div className="">
//                                                 <p className="icon_text">Call Store   </p>
//                                             </div>
//                                         </div>
//                                     </Link> */}
//                 </div>
//               ) : index !== 1 ? (
//                 <div className="">
//                   <p
//                     className={`label ${
//                       step.status === "disabled" ? "disabled-label" : ""
//                     }`}
//                   >
//                     {step.label}
//                   </p>
//                   <p className="description">{step.description}</p>
//                 </div>
//               ) : null}
//             </div>
//           </div>
//         ))}

//       </div>
//     </Box>
//   );
// }

const OrderProgressStepper = ({ order }) => {
  return (
    <div className="OrderProgressStepper">
      <VerticalLinearStepper order={order} />
    </div>
  );
};

export default OrderProgressStepper;
